import * as fromDatatype from '../datatype-library/index';

export interface app_login_mfa_registration_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    app_login_mfa_guid: fromDatatype.GuidDataFieldInterface;
    tenant_guid: fromDatatype.GuidDataFieldInterface;
    website_hdr_guid: fromDatatype.GuidDataFieldInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    name_first: fromDatatype.VarcharDatatypeInterface;
    name_last: fromDatatype.VarcharDatatypeInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    registration_type: fromDatatype.VarcharDatatypeInterface;
    login_method: fromDatatype.VarcharDatatypeInterface;
    registration_key: fromDatatype.VarcharDatatypeInterface;
    email: fromDatatype.VarcharDatatypeInterface;
    phone: fromDatatype.VarcharDatatypeInterface;
    category: fromDatatype.VarcharDatatypeInterface;
    registration_status: fromDatatype.VarcharDatatypeInterface;
    verification_code: fromDatatype.VarcharDatatypeInterface;
    verification_status: fromDatatype.VarcharDatatypeInterface;
    temporary_password: fromDatatype.VarcharDatatypeInterface;
    expiry_date: fromDatatype.TimestampTzDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    post_registration_json: fromDatatype.JsonDatatypeInterface;
    invited_by: fromDatatype.VarcharDatatypeInterface;
    invite_date: fromDatatype.TimestampTzDatatypeInterface;
    principal_type: fromDatatype.VarcharDatatypeInterface;
    principal_id: fromDatatype.VarcharDatatypeInterface;
    valid_date_end: fromDatatype.TimestampTzDatatypeInterface;
    pin_hash: fromDatatype.VarcharDatatypeInterface;
    dob: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}

export class app_login_mfa_registration_RowClass implements app_login_mfa_registration_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    app_login_mfa_guid: fromDatatype.GuidDataFieldInterface;
    tenant_guid: fromDatatype.GuidDataFieldInterface;
    website_hdr_guid: fromDatatype.GuidDataFieldInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    name_first: fromDatatype.VarcharDatatypeInterface;
    name_last: fromDatatype.VarcharDatatypeInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    registration_type: fromDatatype.VarcharDatatypeInterface;
    login_method: fromDatatype.VarcharDatatypeInterface;
    registration_key: fromDatatype.VarcharDatatypeInterface;
    email: fromDatatype.VarcharDatatypeInterface;
    phone: fromDatatype.VarcharDatatypeInterface;
    category: fromDatatype.VarcharDatatypeInterface;
    registration_status: fromDatatype.VarcharDatatypeInterface;
    verification_code: fromDatatype.VarcharDatatypeInterface;
    verification_status: fromDatatype.VarcharDatatypeInterface;
    temporary_password: fromDatatype.VarcharDatatypeInterface;
    expiry_date: fromDatatype.TimestampTzDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    post_registration_json: fromDatatype.JsonDatatypeInterface;
    invited_by: fromDatatype.VarcharDatatypeInterface;
    invite_date: fromDatatype.TimestampTzDatatypeInterface;
    principal_type: fromDatatype.VarcharDatatypeInterface;
    principal_id: fromDatatype.VarcharDatatypeInterface;
    valid_date_end: fromDatatype.TimestampTzDatatypeInterface;
    pin_hash: fromDatatype.VarcharDatatypeInterface;
    dob: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}